module.exports = __webpack_public_path__ + "static/765ca0b6-c280-4767-ab5f-d3944222e486-7470d7938619c1485d696f58f6c38ea9.webp";